

export default class Tiles{
    constructor(){

    }

    addThreeTiles(params){
        let _this = this
        let {
            url = '',
            name = '3dTiles',
            positionModel = {}
        } = params

        let tiles = viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
            name,
            url,
            maximumScreenSpaceError: 1,
            maximumMemoryUsage: 2048,
            show:false
        }))
        let tileFeature = []
        // 放位置 
        tiles.readyPromise.then(function () {
            let position = Cesium.Cartesian3.fromDegrees(positionModel.lon,positionModel.lat,positionModel.alt)
            let modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(position)
            let scale = Cesium.Matrix4.fromUniformScale(100);
            let rotationX = Cesium.Matrix4.fromRotationTranslation(Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(0.3)))
            Cesium.Matrix4.multiply(modelMatrix, rotationX, modelMatrix)
            Cesium.Matrix4.multiply(modelMatrix, scale, modelMatrix)
            tiles._root.transform = modelMatrix
        })

        // 3dtiles模型加载完成后收集所有的特征
        tiles.tileLoad.addEventListener(function (tile) {
            _this.processTileFeatures(tile, function (data) {
                let name = data.getProperty('name')
                if(name.includes('DM')){
                    data.show = true
                    data.color = Cesium.Color.fromCssColorString('#CFCFCF')
                }else if(name.includes('ZhuZi')){
                    data.color = Cesium.Color.fromCssColorString('#828282').withAlpha(0.4)
                }else if(name.includes('QM')){
                    data.color = Cesium.Color.fromCssColorString('#828282').withAlpha(0.4)
                }else if(name.includes('LouTi')){
                    data.color = Cesium.Color.fromCssColorString('#828282').withAlpha(0.4)
                }else{
                    data.show = false
                }
                tileFeature.push(data)
            });
        });
        
        return  {
            tiles,
            tileFeature
        }
    }

    processTileFeatures(tile, callback) {
        let content = tile.content;
        let innerContents = content.innerContents;
        if (Cesium.defined(innerContents)) {
            let length = innerContents.length;
            for (let i = 0; i < length; ++i) {
                this.processContentFeatures(innerContents[i], callback);
                }
            } else {
                this.processContentFeatures(content, callback);
        }
    }

    // 拿到所有的特征
    processContentFeatures(content, callback) {
        let featuresLength = content.featuresLength;
        for (let i = 0; i < featuresLength; ++i) {
            let feature = content.getFeature(i);
            callback(feature);
        }
    }
}